<div class="d-none d-{{switchToScrollBreakpoint}}-block ds-grid container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center flex-nowrap">
        <ul class="nav">
          <ng-container *ngFor="let navItem of splitNavItems[0]">
            <li class="nav-item">
              <a (click)="onNavChange(navItem.id)"
                 (keydown.enter)="onNavChange(navItem.id)"
                 [class.active]="activeNavItem?.id === navItem.id"
                 class="ds-cursor--pointer focusable focusable__element nav-link ds-body ds-color--grey-2"
                 tabindex="0"
              >{{navItem.text | async}}</a>
            </li>
          </ng-container>
          <ng-container *ngIf="splitNavItems[1].length > 0">
            <li class="nav-item dropdown" ngbDropdown placement="bottom-center bottom-left bottom-right">
              <div
                (blur)="dropdown.close()"
                (keydown)="handleKeyboardEvent($event)"
                class="nav-link focusable focusable__element ds-cursor--pointer ds-color--grey-2"
                ngbDropdownToggle
                tabindex="0"
              >
                <span>{{showMoreText}}</span>
                <em class="ms-2 ds-icon--{{dropdown?._open ? 'arrow-up' : 'arrow-down'}}"></em>
              </div>
              <div (mousedown)="$event.preventDefault()" class="mw-100" ngbDropdownMenu>
                <ds-list-group maxHeight="12.5rem">
                  <ds-list-group-item
                    (elementClick)="onNavChange(navItem.id)"
                    *ngFor="let navItem of splitNavItems[1]"
                    [label]="navItem.text | async"
                    [value]="navItem.id"
                  >
                    <div
                      class="d-flex flex-nowrap justify-content-start align-items-center"
                      data-cy="list-sorting-name"
                    >
                      <a
                        [class.active]="activeNavItem?.id === navItem.id"
                        class="nav-link ds-body ds-color--grey-2"
                      >{{navItem.text | async}}</a>
                    </div>
                  </ds-list-group-item>
                </ds-list-group>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="d-{{switchToScrollBreakpoint}}-none w-100 position-relative">
  <div class="horizontal-scrolling-nav">
    <ul class="nav horizontal-scrolling-nav__row">
      <ng-container *ngFor="let navItem of navItems">
        <li class="nav-item">
          <a (click)="onNavChange(navItem.id)"
             (keydown.enter)="onNavChange(navItem.id)"
             tabindex="0"
             [class.active]="activeNavItem?.id === navItem.id"
             class="focusable focusable__element nav-link ds-body ds-color--grey-2 horizontal-scrolling-nav__item navigation-link d-flex align-items-center"
          >{{navItem.text | async}}</a>
        </li>
      </ng-container>
    </ul>
  </div>
  <div class="fading-list-button--left"></div>
  <div class="fading-list-button--right"></div>
</div>
